import { Controller } from 'stimulus';
import axios_rails from '../../lib/axios_rails';
import { handleError } from '../../lib/error';
import { sateiDbCreatePost, transactionIdUrl } from '../../lib/satei_db';

export default class extends Controller {
  static values = {
    name: String,
    email: String,
    campaign: Number,
    memo: String,
    updateUrl: String,
    customer: String,
  };

  async update_trade_satei_no(satei_no, dealing_id) {
    return await axios_rails().patch(this.updateUrlValue, {
      trade: { satei_no: satei_no, dealing_id: dealing_id },
    });
  }

  async create(event) {
    event.preventDefault();
    try {
      const api_res = await sateiDbCreatePost({
        name: this.nameValue,
        email: this.emailValue,
        campaign_rate: this.campaignValue,
        memo: this.memoValue,
        customer: this.customerValue,
      });
      if (api_res) {
        const satei_no = api_res.code;
        const dealing_id = api_res.id;
        const update_res = await this.update_trade_satei_no(
          satei_no,
          dealing_id
        );

        if (update_res.status === 200) {
          window.open(transactionIdUrl(dealing_id), '_blank');
          window.location.reload();
        }
      }
    } catch (error) {
      handleError(error);
    }
  }
}
